<app-page-body [class]="'tw-pt-2'" *ngIf="!isVisibleHelpPage">
  <!-- header -->
  <app-page-header
    custom-header
    [title]="pageVocabs + 'title' | translate"
    [loading]="loading"
    [showAddBtn]="false"
    [showAuditBtn]="false"
    (onShowHelp)="onShowHelpPage()"
  >
    <div class="card-toolbar" after-btns>
      <button
        type="button"
        class="btn btn-success txt-lg button-shadow tw-mx-1 tw-flex-center btn-hover-rise sm:tw-mb-0 tw-mb-2"
        mat-ripple
        (click)="onSaveClick()"
      >
        <span class="tw-mx-1 text-light">
          {{ pageVocabs + "createRequest" | translate }}
        </span>
      </button>
      <!-- open smartSmsRequestConfirmData -->
      <button
        type="button"
        class="btn txt-lg button-shadow tw-mx-1 tw-flex-center btn-hover-rise sm:tw-mb-0 tw-mb-2"
        [themeColor]="'btn-light'"
        mat-ripple
        (click)="openPage('smartSend')"
      >
        <span class="tw-mx-1">{{ "common.requestsList" | translate }}</span>
      </button>
    </div>
  </app-page-header>

  <div class="app-page-content">
    <fieldset class="tw-h-full secondary-panel">
      <!-- smart sms operators -->
      <app-smart-sms-operators
        (selectedOperator)="selectedOperator = $event"
        [isShowToggle]="true"
        [isExistsMCI]="true"
        [isExistsIrancell]="true"
        [isExistsRightel]="true"
        (operators)="operators = $event"
      ></app-smart-sms-operators>

      <div class="row tw-my-4">
        <!-- state -->
        <div class="md:tw-w-1/2">
          <zones-select-search
            #selStates
            label="common.state"
            class="tw-w-full"
            [id]="1"
            [control]="form?.get('stateControl')"
            [value]="stateId"
            (valueChange)="stateId = $event; cityId = -1"
            (onError)="onClose()"
          >
          </zones-select-search>
        </div>
        <!-- end state -->
        <!-- city -->
        <div class="md:tw-w-1/2">
          <zones-select-search
            #citySelectSearch
            label="common.city"
            class="tw-w-full"
            [id]="stateId"
            [control]="form?.get('cityControl')"
            [value]="cityId"
            (valueChange)="onCityChange($event)"
            (onError)="onClose()"
          >
          </zones-select-search>
        </div>
        <!-- end city -->
      </div>

      <!--map -->
      <smart-send-map-control
        #Map
        [Theme]="appStateService.currentThemeMode()"
        [MultiPolygon]="true"
        [ShowAddPublicPlace]="true"
        (OnPublicPlaceClick)="onShowAdvanceSearch()"
        [ShowSaveButton]="false"
      >
      </smart-send-map-control>
    </fieldset>
  </div>
</app-page-body>
<!--------------------------------------------------------------- help ---------------->
<ng-container *ngIf="isVisibleHelpPage">
  <app-help-page
    [menuTitle]="'SendSmartSmsToResidents'"
    (hidePage)="onHideHelpPage()"
    [title]="pageConfig.title"
  >
  </app-help-page>
</ng-container>
